firebird.factory('videoSimulcastToggleService', [
    'logService',
    'configService',
    'helperService',
    'videoGlobalService',
    'attendeeListService',
    'contentService',
    'attendeeService',
    function (
        logService,
        configService,
        helperService,
        videoGlobalService,
        attendeeListService,
        contentService,
        attendeeService
    ) {
        var service = {
            initialize: initialize
        };

        var self, $scope;

        const logger = new LogServiceWrapper(logService, '[videoroomCtrl] videoSimulcastToggleService');

        const idlePhase = 'idle';
        const switchingPhase = 'switching';
        const donePhase = 'done';

        return service;

        function initialize(selfParam) {
            self = selfParam;
            $scope = videoGlobalService.data.$scope;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            // current state of simulcast publisher if video is unmuted.
            self.simulcastFlag = false;

            self.initSimulcastToggle = initSimulcastToggle;
            self.initSimulcastFlag = initSimulcastFlag;
            self.toggleSimulcastIfNeeded = toggleSimulcastIfNeeded;
            self.getIsScreenShareActive = getIsScreenShareActive;
            self.resetSimulcastStartedInRemoteFeeds = resetSimulcastStartedInRemoteFeeds;
            self.markSimulcastTogglePhaseAsIdle = markSimulcastTogglePhaseAsIdle;
            self.markSimulcastTogglePhaseAsSwitching = markSimulcastTogglePhaseAsSwitching;
            self.markSimulcastTogglePhaseAsDone = markSimulcastTogglePhaseAsDone;
            self.isSimulcastTogglePhaseIdle = isSimulcastTogglePhaseIdle;
            self.isSimulcastTogglePhaseSwitching = isSimulcastTogglePhaseSwitching;
            self.isSimulcastTogglePhaseDone = isSimulcastTogglePhaseDone;

            self.simulcastToggleConfig = {
                enabled: false,
                onBitrateLow: false,
                pauseOnRestart: true, // pause videos on restart or stay with black video box
                disableCutoff: 12, // if video count increases > 12 then disable simulcast
                enableCutoff: 10, // if video count decreases <= 10 then re-enable simulcast
                constraints: {
                    width: 320,
                    height: 180,
                    frameRate: 15
                }
            };

            // these state attributes together determine whether the simulcastFlag is set or not.
            self.simulcastToggleState = {
                attendeeCount: 0,
                videoCount: 0,
                contentPlaying: false,
                bitrateLow: false,
                restricted: false, // true if simulcast disabled due to large video count with content playing.
                phase: idlePhase // possible values: 'idle', 'switching', 'done'
            };

            $scope.$on('attendee-list-count-updated', onAttendeeListCountUpdated);
            $scope.$on('video-feed-count', onVideoFeedCountChange);
            $scope.$on('internal-content-stopped', onContentStopped);
            $scope.$on('internal-content-playing', onContentPlaying);
            $scope.$on('internal-content-status', onContentStatus);
        }

        function initSimulcastToggle() {
            self.setConfigObjectFromValue(
                'enableSimulcastToggle',
                configService.getValue('enableSimulcastToggle'),
                self.simulcastToggleConfig
            );

            // should not be higher than 'low video' resolution
            const config = self.simulcastToggleConfig;
            config.constraints.width = Math.min(config.constraints.width, 640);
            config.constraints.height = Math.min(config.constraints.height, 360);

            if (self.simulcastAt === 0 || self.simulcastAt === self.simulcastAtMax) {
                config.enabled = false;
                config.onBitrateLow = false;
                logger.log('initSimulcastToggle', `disabled due to pre-configured simulcastAt=${self.simulcastAt}`);
            } else {
                config.disableCutoff = Math.max(config.disableCutoff, self.simulcastAt);
                config.enableCutoff = Math.min(config.enableCutoff, config.disableCutoff);
            }

            if (config.enabled) {
                logger.log('initSimulcastToggle', `enabled with config ${JSON.stringify(config)}`);
            }
        }

        function initSimulcastFlag() {
            const config = self.simulcastToggleConfig;

            const data = {
                attendeeCount: attendeeListService.getAttendeeCountForSimulcastCondition().length
            };

            if (config.enabled) {
                data.contentPlaying = self.getIsScreenShareActive();
                data.videoCount = self.videoFeedCount;

                if (!attendeeService.getIsVideoMuted()) {
                    data.videoCount += 1;
                }
            }

            self.toggleSimulcastIfNeeded(data, true);
        }

        function onContentPlaying(e, data) {
            if (!helperService.getIsMeetingEnding()) {
                self.toggleSimulcastIfNeeded({ contentPlaying: data.ownerID > 0 });
            }
        }

        function onContentStopped(e, data) {
            if (!helperService.getIsMeetingEnding()) {
                self.toggleSimulcastIfNeeded({ contentPlaying: false });
            }
        }

        function onContentStatus(e, data) {
            if (!helperService.getIsMeetingEnding()) {
                self.toggleSimulcastIfNeeded({ contentPlaying: data.state === 'running' });
            }
        }

        function onAttendeeListCountUpdated(e, data) {
            self.toggleSimulcastIfNeeded({ attendeeCount: data.new });
        }

        function onVideoFeedCountChange(e, count) {
            if (!helperService.getIsMeetingEnding()) {
                self.toggleSimulcastIfNeeded({ videoCount: count });
            }
        }

        function toggleSimulcastIfNeeded(data, initOnly) {
            const config = self.simulcastToggleConfig;
            const state = self.simulcastToggleState;

            if (data) {
                // TODO: only these attributes in data should be allowed: contentPlaying, attendeeCount, videoCount, bitrateLow.
                Object.assign(state, data);
            }

            const oldValue = self.simulcastFlag;

            if (config.enabled && !(self.simulcastAt === 0 || self.simulcastAt === self.simulcastAtMax)) {
                // There could be a situation when video count is between the cutoffs. For newly joined attendee we don't know
                // simulcast state: it could be true, because we not reached the disableCutoff or false, because
                // previously we reached the disableCutoff, then turned off some webcams, but not reached enableCutoff.
                // In this case joined attendee will have different simulcast state.
                const cutoff = oldValue || initOnly ? config.disableCutoff : config.enableCutoff - 1;
                const largeVideoCount = state.videoCount > cutoff;
                const enoughAttendees = state.attendeeCount >= self.simulcastAt;
                const largeVideoWithContent = largeVideoCount && state.contentPlaying;
                const bitrateLow = self.simulcastToggleConfig.onBitrateLow && state.bitrateLow;
                const newValue = !bitrateLow && enoughAttendees && !largeVideoWithContent;
                state.restricted = enoughAttendees && (largeVideoWithContent || bitrateLow);

                if (oldValue !== newValue) {
                    self.simulcastFlag = newValue;

                    logger.log(
                        'setSimulcastStateFlag',
                        `simulcastFlag ${oldValue} to ${newValue}, state is ${JSON.stringify(state)}`
                    );
                }
            } else {
                // old condition
                self.simulcastFlag = state.attendeeCount >= self.simulcastAt;
            }

            if (!initOnly && oldValue !== self.simulcastFlag) {
                self.markSimulcastTogglePhaseAsSwitching();
                self.republishAfterSimulcastChanged();

                if (!self.simulcastFlag) {
                    // also reset the simulcastStarted flags of various remote feeds.
                    // TODO: this will not work if different simulcastAt values are used for different clients,
                    // or if simulcast publish is always enabled, e.g., on mobile clients. or different
                    // clients in the meeting have different enableSimulcastToggle config.
                    self.resetSimulcastStartedInRemoteFeeds();
                }
            }
        }

        function getIsScreenShareActive() {
            // TODO: need to include multishare too
            return contentService.getIsScreenShareActive();
        }

        function resetSimulcastStartedInRemoteFeeds() {
            for (let s in self.feeds) {
                let feed = self.feeds[s];
                if (typeof feed === 'object' && feed.simulcastStarted) {
                    // may be undefined, true or false
                    feed.simulcastStarted = false;
                }
            }
        }

        function markSimulcastTogglePhaseAsIdle() {
            setSimulcastTogglePhase(idlePhase);
        }

        function markSimulcastTogglePhaseAsSwitching() {
            setSimulcastTogglePhase(switchingPhase);
        }

        function markSimulcastTogglePhaseAsDone() {
            setSimulcastTogglePhase(donePhase);
        }

        function setSimulcastTogglePhase(phase) {
            self.simulcastToggleState.phase = phase;
        }

        function isSimulcastTogglePhaseIdle() {
            return self.simulcastToggleState.phase === idlePhase;
        }

        function isSimulcastTogglePhaseSwitching() {
            return self.simulcastToggleState.phase === switchingPhase;
        }

        function isSimulcastTogglePhaseDone() {
            return self.simulcastToggleState.phase === donePhase;
        }
    }
]);
